//Enums

import { MessageHolder } from '@components/UI/AiModal/TabContent/GeneralTab';
import { Task } from '../config/task';
import { AskListType } from '@components/UI/AiModal/TabContent/KnowledgebaseTab';

export enum priority {
  none = 'none',
  high = 'high',
  medium = 'medium',
  low = 'low',
}

export enum UpcomingView {
  weekNow = 'week-now',
  weekNext = 'week-next',
  monthNow = 'month-now',
  monthNext = 'month-next',
}

export enum DependencyType {
  subtask = 'subtask',
  risk = 'risk',
  issue = 'issue',
  decision = 'decision',
  dependency = 'dependency',
  milestone = 'milestone',
}

export enum FocusArea {
  none = 'none',
  people = 'people',
  process = 'process',
  technology = 'technology',
}

export enum Impact {
  none = 'None',
  high = 'High',
  medium = 'Medium',
  low = 'Low',
}

export enum LikeliHood {
  none = 'None',
  high = 'High',
  medium = 'Medium',
  low = 'Low',
}

export enum DashboardWidgets {
  Accomplishments = 'Accomplishments',
  FreeText = 'FreeText',
  DealBackground = 'DealBackground',
  BurndownChart = 'BurndownChart',
  MilestoneProgressTracker = 'MilestoneProgressTracker',
  WorkstreamStatus = 'WorkstreamStatus',
  ActionItems = 'ActionItems',
  DependenciesIncoming = 'DependenciesIncoming',
  DependenciesOutgoing = 'DependenciesOutgoing',
  ConflictTracker = 'ConflictTracker',
  DependencyResolvedItems = 'DependencyResolvedItems',
  RiskQuadrant = 'RiskQuadrant',
  UpcomingTasks = 'UpcomingTasks',
  SankeyChart = 'SankeyChart',
}

export enum complianceType {
  none,
  regulatory,
  legal,
  datasecurity,
  labor,
  envSust,
  quality,
  healthSafety,
}

export enum ProjectType {
  GENERAL = 'general',
  MERGER = 'merger',
}

export interface FilterKeyValueProps {
  key: string;
  text: string;
  value: boolean;
  index: number;
}

export interface FilterFields {
  assignedTo: string[];
  assignedToMe: boolean;
  dayOne: boolean;
}

//Dashboard interfaces

export interface ICDashboardComponent {
  name: string;
  content: any;
}

export interface InvitetoDealUsers {
  name: string;
  phone: string;
  inviteStatus: string;
  surname: string;
  userStatus: string;
  userRole: string;
  username: string;
  companyRole: string;
  playbookId: string;
  createdAt: string;
  projectUserId?: string;
  dealspaceUserId?: string;
  inviteDate?: string;
}

export interface InvitetoDealComponents {
  playbookId: string;
  playbookName: string;
  functionalAreaName: string;
  functionalAreaId: string;
  user: InvitetoDealUsers[];
  index: number;
  color?: string;
}

export interface FunctionalAreaDto {
  name: string;
  dealspaceId: string;
  color: string;
  parentFunctionId?: string;
  shortName: string;
  taskPrefix?: string;
}

export interface ICOverallProgressElement {
  name: string;
  totalItem: number;
  finishedItem: number;
  dueDate: string;
}
export interface ICOverallProgress {
  totalItem: number;
  finishedItem: number;
  dueDate: string;
  milestones: ICOverallProgressElement[];
}

export interface ICFunctionStatusElement {
  name: string;
  status: string;
  riskCount: number;
  issuesCount: number;
  decisionCount: number;
}
export interface ICFunctionStatus {
  functions: ICFunctionStatusElement[];
}

export interface PlaybookSectionTasks {
  [key: string]: ICTask[];
}

export interface ICActionItems {
  totalRisk: number;
  totalIssues: number;
  totalDecision: number;

  highlyRisk: number;
  mediumRisk: number;
  lowRisk: number;
  unassignedRisk: number;

  higlyIssues: number;
  mediumIssues: number;
  lowIssues: number;
  unassignedIssues: number;

  highlyDecision: number;
  mediumDecision: number;
  lowDecision: number;
  unassignedDecision: number;
}

export interface ICFocusArea {
  peapleTotal: number;
  peopleFinished: number;

  progressTotal: number;
  progressFinished: number;

  technologyTotal: number;
  technologyFinished: number;
}

export interface ICDependeciesElement {
  name: string;
  taskCount: number;
}

export interface ICDependecies {
  dependencies: ICDependeciesElement[];
}

//List view interfaces
export interface ICTaskAttachment {
  id: string;
  createdAt: string;
  documentId: string;
  document: ICDocument;
  taskId: string;
}

export interface ICDocument {
  name: string;
  createdAt: string;
  createdBy: string;
  size: any;
}

export interface ICTaskComment {
  id: string;
  comment: string;
  taskId: string;
  username: string;
  createdAt: string;
}

export interface ICTaskLog {
  columnName: string;
  description: string;
  newValue: string;
  oldValue: string;
  taskId: string;
  username: string;
  createdAt: string;
}

export interface ICTaskProject {
  taskId: string;
  projectId: string;
  sectionId: string;
}

export interface ICTaskRisk {
  impact: string;
  likelihood: string;
  updatedBy: string;
}

export interface ICTaskDecision {
  decisionMode: string;
  updatedBy: string;
}

export interface ICTaskIssue {
  impact: string;
  updatedBy: string;
}

export interface Tagger {
  id: string;
  text: string;
}

export interface ChangeSectionResponse {
  taskId: string;
  sectionId: string;
  sectionNumber: number;
  childTaskIds: string[];
}

export interface ICTask {
  projectId?: string;
  id?: string;
  type?: 'subtask' | 'risk' | 'decision' | 'issue' | 'dependency' | string;
  dealspaceId?: string;
  name?: string;
  playbookId?: string;
  sectionId?: string;
  sectionName?: string;
  acknowledged?: boolean;
  childTasks?: ICTask[];
  complianceType?: complianceType;
  itemNumber?: string;
  commentCount?: string;
  orderNumber?: number;
  dependency?: {
    functionalAreaId: string;
    id: string;
  };
  dayOne?: boolean;
  createdAt?: string;
  completionDate?: string;
  projectRelType?: string;
  isDeleted?: boolean;
  parentTaskName?: string;
  attachmentCount?: string;
  treeLocation?: string;
  focusArea?: FocusArea;
  integrationDueDiligence?: boolean;
  integrationPlanning?: boolean;
  sourceDeleted?: boolean;
  oneTimeCost?: number;
  synergyAchieved?: number;
  targetSynergy?: number;
  assignee?: string | null;
  isArchived?: boolean;
  description?: string;
  riskImpact?: string;
  riskLikelihood?: string;
  issueImpact?: string;
  dependentFunction?: string;
  dueDate?: string | null;
  isCompleted?: boolean;
  hasDescription?: boolean;
  parentId?: string;
  priority?: priority;
  startDate?: string;
  reporter?: string;
  risks?: ICTaskRisk;
  decision?: ICTaskDecision;
  decisionMaker?: string[];
  issue?: ICTaskIssue;
  subTaskCount?: number;
  riskCount?: number;
  decisionCount?: number;
  issueCount?: number;
  dependenciesCount?: number;
  comments?: ICTaskComment[];
  logs?: ICTaskLog[];
  attachments?: ICTaskAttachment[];
  projects?: ICTaskProject[];
  task?: Task;
  subTasks?: Task[];
  dependencyConflictTasks?: Task[];
  dueDateConflictTasks?: Task[];
  childsOneTimeCost?: number;
  playbookFunction?: string;
  dependencySource?: string;
  dependencyTarget?: string;
  isLineSummary?: boolean;
  [key: string]: any;
}

export interface AiHistoryModel {
  messageHolder: MessageHolder[];
  conversationId: string;
  name: 'General' | 'Document' | 'Knowledgebase' | string;
  askListType: AskListType | null;
}
export interface sectionOrders {
  taskId: string;
  sectionId: string;
  sectionOrder: number;
  childTaskIds: string[];
}

export interface taskFamilyOrders {
  taskId: string;
  familyOrder: number;
}

export interface TaskResponse {
  taskDto: ICTask[];
  sectionOrders?: sectionOrders[];
  familyOrders?: taskFamilyOrders[];
}

export interface ICTaskList extends ICTask {
  parent: number | string;
  text: string;
  droppable: boolean;
  id: string;
}
export interface ICSection {
  name: string;
  id: string;
  tasks: ICTask[];
  priority?: number;
}

export interface ICListView {
  sections: ICSection[];
  tasks: ICTask[];
}

export interface PlayBookRequest {
  playbookId: string;
  type: string;
  settings: any;
}

export interface PaymentDto {
  dealspaceId: string;
  subscriptionType: string;
  playbookIds: string[];
  successUrl: string;
  cancelUrl: string;
  aiEnabled: boolean;
}

export interface AiUserCountDTO {
  dealspaceId: string;
  playbookIds: string[];
}

export interface WorkstreamManageDTO {
  dealProject: DealProjectDTO[];
  mergefloDealspaceUsers: MergefloDealspaceUsers[];
}

export interface UserGeneralSettings {
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  username: string;
  isActive: boolean;
  name: string;
  surname: string;
  companyRole?: string;
  userRole?: string;
  phone?: string;
  notifications?: string[];
  playbookSettings: any;
  isVerified: boolean;
}

export interface ICPlaybook {
  name: string;
  id: string;
}

export interface ICDealspace {
  name: string;
  id: string;
  signDate: string | null;
  closeDate: string | null;
  dayOneDate: string | null;
  buyerCompany: string;
  sellerCompany: string;
}

export interface TemplateDTO {
  templateId: string;
  templateName: string;
}

export interface ProjectUser {
  inviteDate: Date;
  projectUserId: string;
  username: string;
  inviteStatus: string;
  userStatus: string;
  userRole: string;
  playbookName: string;
  playbookId: string;
  functionalAreaId: string;
  functionalArea: string;
  color: string;
  name: string;
  surname: string;
  companyRole: string;
  phone: string;
}

export interface PlaybookSummary {
  projectId: string;
  projectName: string;
  taskCount: string;
  milestoneCount: string;
  riskCount: string;
  issueCount: string;
  dependencyCount: string;
  decisionCount: string;
  playbookUsers: ProjectUser[];
}

export interface ProjectDto {
  createdBy: string;
  updatedBy: string;
  createdAt: Date;
  updatedAt: Date;
  id: string;
  name: string;
  type: string;
  isDeleted: boolean;
  workspaceId: string;
  taskPrefix: string;
  parentProjectId?: any;
  isTemplate: boolean;
  templateProjectId?: any;
  isFree?: boolean;
}

export interface DealProjectDTO {
  id: string;
  functionalAreaId: string;
  project: ProjectDto;
  functionalArea?: ICFunctionalArea;
}

export interface NewDealProjectDTO {
  name?: string;
  dealspaceId?: string;
  taskPrefix?: string;
  functionalArea?: {
    name?: string;
    shortName?: string;
    color?: string;
  };
}
export interface ICFunctionalArea {
  color?: string;
  createdAt?: string;
  createdBy?: string;
  dealspaceId?: string;
  id: string;
  isDeleted: boolean;
  isIMO: boolean;
  name: string;
  parentFunctionId?: string;
  shortName?: string;
  templatePlaybookId?: string;
  updatedAt?: string;
  updatedBy?: string;
  functionalAreaTypeId?: string;
  functionalAreaType?: FunctionalAreaType;
}

export interface ICSelectPlaybook {
  playbookId: string;
  dealspaceId: string;
  playbookName: string;
  dealspaceName: string;
}

export interface ICCreateDealspace {
  dealspaceName: string;
  userRole: string;
  functionalAreaId: string;
  functionalAreaTypeId: string;
  playbookName: string;
  taskPrefix: string;
}

export interface ICSessionUser {
  username?: string;
  isActive?: boolean;
  name: string;
  surname: string;
  companyRole: string;
  phone: string;
  notifications?: string[] | null;
}

export interface ISUpdateCoreTask {
  assignee?: string | null;
  description?: string;
  dueDate?: string | null;
  isCompleted?: boolean;
  name?: string;
  parentId?: string;
  priority?: priority;
  startDate?: string;
  isArchived?: boolean;
}

export interface ISUpdateMergefloTask {
  acknowledged?: boolean;
  complianceType?: complianceType;
  dayOne?: boolean;
  focusArea?: FocusArea;
  integrationDueDiligence?: boolean;
  integrationPlanning?: boolean;
  oneTimeCost?: number;
  synergyAchieved?: number;
  targetSynergy?: number;
}

export interface ISUpdateTaskProject {
  projectId: string;
  taskId: string;
  sectionId: string;
  referenceTaskId?: string;
  isBefore?: boolean;
}

export interface ISUpdateMergefloDealspaceUser {
  ownerUsername: string;
}

export interface MergefloDealspaceUsers {
  companyRole: string;
  functionalArea: string;
  functionalAreaId: string;
  inviteStatus: string;
  name: string;
  phone: string;
  playbookId: string;
  playbookName: string;
  projectUserId: string;
  surname: string;
  userRole: string;
  userStatus: string;
  username: string;
  createdAt?: string;
  inviteDate?: string;
  isIMO?: boolean;
}

export interface ISUpdateMergefloPlaybook {
  name?: string;
  taskPrefix?: string;
}

export interface ISUpdateMergefloPlaybookSection {}

export interface ISUpdateMergefloPlaybookUser {
  userRole: string;
  userStatus: string;
}

export interface UserPlaybook {
  id: string;
  inviteStatus: string;
  name: string;
  surname: string;
  userRole: string;
  userStatus: string;
  username: string;
}

export interface ISUpdateCoreIssue {
  impact: Impact;
}

export interface ISUpdateCoreRisk {
  impact: Impact;
  likelihood: LikeliHood;
  id: string;
}

export interface ISUpdateCoreDecision {
  decisionMade?: string;
  decisionMaker?: string[];
}

export interface ISUpdateCoreTaskComment {
  comment: string;
}

export interface ISUpdateCoreWorkspace {}

export interface ISUpdateCoreWorkspaceUser {
  userRole: string;
  userStatus: string;
}

export interface ISUpdateMergefloDependency {
  functionalAreaId: string;
}

export interface ISUpdateCoreProject {
  taskPrefix?: string;
  name: string;
}

export interface ISUpdateCoreProjectSection {
  name: string;
}

export interface ISUpdateCoreProjectUser {
  userRole: string;
  userStatus?: string;
}

export interface ISError {
  messaege: string;
  data?: any;
}

export interface AiQueryResponse {
  createdBy: string;
  promptText: string;
  conversationId: string;
  requestTime: string;
  responseTime: string;
  processTime: number;
  result: string;
  promptToken: number;
  resultToken: number;
  totalUsedToken: number;
  temperature: number;
  chain_type: string;
  updatedBy: any;
  promptId: any;
  createdAt: string;
  updatedAt: string;
  id: string;
}

export interface ISSuccess {
  message: string;
  data?: any;
}
export interface ISServiceResponse {
  statusCode: string;
  error?: ISError;
  success?: ISSuccess;
  data?: any;
}

export interface ISCreateSection {
  projectId: string;
  sectionName: string;
}

export interface ICSubTaskCreate {
  name: string;
  parentId: string;
}

export interface ISCreateIssue {
  name: string;
  parentId: string;
}

export interface AiPrompt {
  id: string;
  prompt: string;
  categoryId: string;
}

export interface AiPromptCategory {
  id: string;
  name: string;
}

export interface ISCreateRisk {
  name: string;
  parentId: string;
  workspaceId: string;
}

export interface ISCreateDecision {
  name: string;
  parentId: string;
}

export interface ISCreateDependency {
  name: string;
  parentId: string;
  functionalAreaId: string;
}

export interface ISCreateComment {
  comment: string;
  taskId: string;
}

export interface ISSection {
  id: string;
  projectId: string;
  name: string;
}

export interface ISConfirmPassword {
  password: string;
  token: string;
  username: string;
}

export interface ISResetPassword {
  newPassword: string;
  oldPassword: string;
  username: string;
}

export interface ISLoginUserResponse {
  idToken: IdToken;
  refreshToken: RefreshToken;
  accessToken: AccessToken;
  clockDrift: number;
  message?: string;
  statusCode?: string;
}

export interface IdToken {
  jwtToken: string;
  payload: Payload;
}

export interface Payload {
  sub: string;
  email_verified: boolean;
  iss: string;
  'cognito:username': string;
  origin_jti: string;
  aud: string;
  event_id: string;
  token_use: string;
  auth_time: number;
  name: string;
  exp: number;
  iat: number;
  jti: string;
  email: string;
}

export interface RefreshToken {
  token: string;
}

export interface AccessToken {
  jwtToken: string;
  payload: Payload2;
}

export enum SubscriptionType {
  TRIAL = 'trial',
  FREE = 'free',
  DEALPLAYBOOK = 'dealPlaybook',
  SUBSCRIPTION = 'subscription',
  USERBASEPAID = 'userBasePaid',
}

export interface Payload2 {
  sub: string;
  iss: string;
  client_id: string;
  origin_jti: string;
  event_id: string;
  token_use: string;
  scope: string;
  auth_time: number;
  exp: number;
  iat: number;
  jti: string;
  username: string;
}

export interface ISDealspaceDirectory {
  functionalAreaId: string;
  functionalArea: string;
  username: string;
  name?: string;
  surname?: string;
  inviteStatus?: string;
  dealspaceId?: string;
  createdAt?: string;
  playbookId?: string | null;
  phone?: string;
  companyRole?: string;
  dealspaceUserId: string;
  inviteDate?: string;
}

export interface DealspaceSubscription {
  subscription: Subscription;
  period: Period;
  items: Item[];
}

export interface FunctionalAreaType {
  createdBy: string;
  updatedBy: any;
  createdAt: string;
  updatedAt: string;
  id: string;
  name: string;
  shortName: string;
  isActive: boolean;
  isDeleted: boolean;
}

export interface Subscription {
  createdBy: string;
  updatedBy: any;
  createdAt: string;
  updatedAt: string;
  id: string;
  workspaceId: string;
  status: string;
  aiEnabled: string;
  aiCancelled: string;
  active: boolean;
}

export interface Period {
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  workspaceId: string;
  subscriptionId: string;
  startDate: string;
  endDate: string;
  isPaid: boolean;
  paymentStatus: string;
  active: boolean;
}

export interface Item {
  createdBy: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  periodId: string;
  registerDate: string;
  dropDate?: string;
  projectId: string;
}

export interface ISDealspaceUser {
  projectUserId: string;
  playbookId: string;
  playbookName: string;
  functionalAreaId: string;
  functionalArea: string;
  inviteStatus: string;
  username: string;
  userRole: string;
  userStatus: string;
  name: string;
  surname: string;
}
export interface ICDropzoneProps {
  taskId: string;
}

export interface ICNotification {
  id: string;
  createdAt: string;
  message: string;
  type: string;
  source: string;
  target: string;
  taskId: string;
  taskCommentId?: string;
  read: boolean;
  count: number;
}

export interface ICNotificationDefinition {
  type: string;
  actionType: string;
  alertType: string;
  userRelType: string;
  description: string;
}

export interface DecisionMakerProps {
  name: string;
  count: number;
  relatedTasks: ICTask[];
}

export interface ICExcelHeader {
  label: string;
  value: string;
}

export interface ICExcelSheetData {
  name: string;
  headers: ICExcelHeader[];
  rows: any[];
}

export interface ICExcelData {
  fileName: string;
  dataset: ICExcelSheetData[];
}

export interface ICUserDealspace {
  id: string;
  name: string;
  dealspaceOwner: string;
  buyerCompany: string;
  sellerCompany: string;
  signDate: string;
  closeDate: string;
  dayOneDate: string;
  notificationCount: string;
  taskCount: number;
  createdAt: string;
  trialEndDate?: string;
  subscriptionType?: SubscriptionType;
}

export interface ICValidationResult {
  type: string;
  row: string;
  column: string;
  message: string;
}

export interface ICImportPlaybookResponse {
  sectionCount: number;
  taskCount: number;
  subtaskCount: number;
  dependencyCount: number;
  riskCount: number;
  issueCount: number;
  decisionCount: number;
  totalCount: number;
  validationResult: ICValidationResult[];
}
export interface ICFreeText {
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  id: string;
  isDeleted?: boolean;
  text?: string;
  title?: string;
  type?: string;
  date?: string;
}

export interface ICJWTToken {
  name: string;
  exp: number;
}

export interface ICWidget {
  title: string;
  text: string;
  order: string;
  visible: boolean;
  type: string;
}

export interface DashboardView {
  name: DashboardWidgets;
  visible: boolean;
  order: number;
}

export interface WSDashboardView {
  workstreamID: string;
  widgets: DashboardView[];
}

export interface ProjectTemplate {
  id?: string;
  projectId?: string;
  name?: string;
  username?: string;
  description?: string;
  isDeleted?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface Project {
  id?: string;
  name?: string;
  type?: ProjectType;
  isDeleted?: boolean;
  workspaceId?: string;
  taskPrefix?: string;
  parentProjectId?: string;
  parentProject?: Project;
  isTemplate?: boolean;
  templateProjectId?: string;
  importedTemplateIds?: string[];
  isFree?: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ProjectPlaybook {
  id: string;
  functionalAreaId: string;
  project: Project;
}

export interface SectionDDProps {
  projectId: string;
  sectionId: string;
  sectionOrder: number;
}

export interface AiQueryResponse {
  totalRowCount: number;
  rows: Row[];
}

export interface Row {
  createdBy: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
  functionalAreaTypeId?: string;
  id: string;
  name: string;
  prompt: string;
  related: string;
  resType: string;
  context: string;
  categoryId: string;
  notes?: string;
  isActive: boolean;
  isDeleted: boolean;
  sourceDocs: SourceDoc[];
}

export interface SourceDoc {
  createdBy: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  aiPromptId: string;
  aiSourceDoc: AiSourceDoc;
}

export interface AiSourceDoc {
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  description: string;
  name: string;
  isDeleted: boolean;
  isAiUpdated: boolean;
  document: Document;
}

export interface Document {
  createdAt: string;
  createdBy: string;
  name: string;
  size: string;
  removedFromS3: boolean;
}

export interface AiCategoriesResponse {
  totalRowCount: number;
  rows: CategoryRow[];
}

export interface CategoryRow {
  createdBy: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  name: string;
  description: string;
  parentId?: string | null;
  isDeleted: boolean;
}

export interface AiHistoryList {
  createdBy: string;
  updatedBy: any;
  createdAt: string;
  updatedAt: string;
  id: string;
  name: string;
  workspaceId: any;
  projectId: any;
  queryType: string;
}

export interface HistoryResponse {
  totalRowCount: number;
  rows: AiHistoryList[];
}

export interface ContentResponse {
  prompt: string;
  promptId: string;
  response: string;
  queryTime: string;
}
